// extracted by mini-css-extract-plugin
module.exports = {"section":"I_section__Lv_8Y","pulse-scale":"I_pulse-scale__HlO63"};